// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"965":"a00515e7","1575":"a3057b31","1705":"f0665e08","3143":"a3057b31","8649":"3aadb777"}[chunkId] + ".chunk.css";
};